import useLocale from '../../Hooks/use-locale';
import useTypeSafeLocalize from '../../Hooks/use-type-safe-localize';
import { Label } from '../../SubComponents/Text';
import { LocalizationCategory, ProductLocalization } from '../../localizations/types';

type LocalizationFields = {
  da?: string | null;
  en?: string | null;
  sv?: string | null;
  de?: string | null;
  es?: string | null;
  fr?: string | null;
  it?: string | null;
};
interface CustomerFormHelpTextProps {
  customerFormHeading?: LocalizationFields | null;
  customerFormText?: LocalizationFields | null;
}

const CustomerFormHelpText = (props: CustomerFormHelpTextProps) => {
  const { languageAsEnum } = useLocale();
  const localize = useTypeSafeLocalize();

  const heading = props.customerFormHeading?.[languageAsEnum];
  const text = props.customerFormText?.[languageAsEnum];

  return (
    <>
      {heading && (
        <Label bold mb="1" textAlign="center">
          {heading}
        </Label>
      )}

      <Label mb="4" textAlign="center">
        {text
          ? text
          : localize(
              LocalizationCategory.product,
              ProductLocalization.yourInformationBookingHeld
            )}
      </Label>
    </>
  );
};

export default CustomerFormHelpText;
